// extracted by css-extract-rspack-plugin
export default {"container":"jnNumWijZBw729hQ","lobby":"uesPoaDTv2cHfs36"};